import React, {Component} from 'react';
import {Checkbox} from "@blueprintjs/core";

// Components
import {documentTypes} from "../common/document_types";

class UpdateSerieDialog extends Component {
    constructor(props) {
        super(props);

        const docType = documentTypes
            .filter(docType => docType.get('type') === this.props.serie.get('document_type'))
            .get(0)
            .get('desc')
        ;

        this.state = {
            docType,
            name: this.props.serie.get('name') || '',
            prefix: this.props.serie.get('prefix') || '',
            number_length: this.props.serie.get('number_length') || 3,
            last_count: this.props.serie.get('last_count') || 0,
            is_default: this.props.serie.get('is_default') || false
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    onSaveButtonClick = () => {
        this.props.updateSerie(this.props.serie.get('_id'), {
            document_type: this.props.serie.get('document_type'),
            name: this.state.name,
            prefix: this.state.prefix,
            number_length: this.state.number_length,
            last_count: this.state.last_count,
            is_default: this.state.is_default,
        });
        this.props.onCloseModal();
    };

    validateSubmit = () => {
        const canSubmit = this.state.document_type !== -1 &&
            this.state.document_type !== -1 &&
            this.state.name !== '' &&
            this.state.number_length >= 3 &&
            this.state.last_count !== ''
        ;

        this.props.onCanSubmit(canSubmit);
    };

    render() {
        return (
            <div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Tipo de documento *</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.docType}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Nombre *</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.name}
                            onChange={(event) => this.setState({ name: event.target.value }, this.validateSubmit) }
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Prefijo</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.prefix}
                            onChange={(event) => this.setState({ prefix: event.target.value }, this.validateSubmit) }
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Dígitos (mínimo 3) *</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.number_length}
                            onChange={(event) => this.setState({ number_length: event.target.value }, this.validateSubmit) }
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Último número *</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.last_count}
                            onChange={(event) => this.setState({ last_count: event.target.value }, this.validateSubmit) }
                        />
                    </div>
                </div>
                <div className="row modal-row" style={{ paddingTop: 15 }} >
                    <div className="col-1">
                        <Checkbox
                            checked={this.state.is_default}
                            onChange={event => this.setState({ is_default: event.target.checked }, this.validateSubmit)}
                        />
                    </div>
                    <div className="col" style={{ paddingLeft: 0 }} >
                        <span style={{ fontSize: 14 }} >Marcar como <strong>serie por defecto</strong> para este tipo de documentos</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default UpdateSerieDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/UpdateSerieDialog.js